<template>
  <div>
    <b-table
      hover
      :items="items"
      :busy="loading"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
          <strong class="text-secondary">Loading...</strong>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { BSpinner, BTable } from 'bootstrap-vue'
import * as Services from './services'

export default {
  components: {
    BSpinner,
    BCardCode,
    BTable,
  },
  setup() {
    const { Top5User } = Services
    const { data: visitorData } = Top5User()
    return {
      visitorData,
      loading : true
    }
  },
  computed: {
    items() {
      let items = []
      for (let index = 0; index < 5; index++) {
        items.push({
          top_5_visitor: !this.visitorData[index] ?  '-' : this.visitorData[index].user.NAME ? this.visitorData[index].user.NAME : this.visitorData[index].user.USERNAME,
          views: !this.visitorData[index] ?  '-' : this.visitorData[index].count ? this.visitorData[index].count : this.visitorData[index].count,
        })
      }
      return items
    }
  },
  watch: {
    visitorData: function (newVal, oldVal) {
      this.loading = false
    }
  }
}
</script>